
const buildProductEvent = (product, data) => ({
  category: 'Product',
  label: product.name,
  value: product.id,
  ...data,
});

export const PRODUCT_MORE_DETAILS = product =>
  buildProductEvent(product, { event: 'More Details' });

export const PRODUCT_IMAGE_CLICK = product =>
  buildProductEvent(product, { event: 'Image Click' });

export const  PRODUCT_THUMBNAIL_CLICK = (product, index) =>
  buildProductEvent(product, { event: 'Choose Thumbnail', value: index });

const userEvent = data => ({
  category: 'User',
  ...data,
});

export const CONTACT_US_CLICK = () => userEvent({
  event: 'Contact',
  label: 'Email',
});

export const SOCIAL_LINK_CLICK = (type) => userEvent({
  event: 'Contact',
  label: 'Social',
  value: type,
});

export const NAVIGATION_CLICK = (item) => userEvent({
  event: 'Navigation',
  label: item,
});

export const IMAGE_THUMBNAIL_CLICK = (label, index) => ({
  category: 'Image',
  event: 'Choose Thumbnail',
  label,
  value: index,
});



// WEBPACK FOOTER //
// ./src/util/events.js